module.exports = __webpack_public_path__ + "static/media/work1.8727ceed.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/work1.png
// module id = 3
// module chunks = 0